import { render, staticRenderFns } from "./TypeOfUser.vue?vue&type=template&id=21affbf8&"
import script from "./TypeOfUser.vue?vue&type=script&lang=js&"
export * from "./TypeOfUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21affbf8')) {
      api.createRecord('21affbf8', component.options)
    } else {
      api.reload('21affbf8', component.options)
    }
    module.hot.accept("./TypeOfUser.vue?vue&type=template&id=21affbf8&", function () {
      api.rerender('21affbf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/Admin/TypeOfUser.vue"
export default component.exports